import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as SupplierActions from '../../actions/master-data/supplier.actions';

@Injectable()
export class SupplierEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) {}

  loadSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.loadSuppliers),
      mergeMap(() =>
        this.masterDataService.getAllSuppliers().pipe(
          map((suppliers) => SupplierActions.loadSuppliersSuccess({ suppliers })),
          catchError((error) => {
            let errorMessage = 'An error occurred loading suppliers.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(SupplierActions.loadSupplierFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  addSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.addSupplier),
      mergeMap(({ supplier }) =>
        this.masterDataService.addNewSupplier(supplier).pipe(
          mergeMap(saved => [
            SupplierActions.addSupplierSuccess({
              supplier: saved,
              message: 'Supplier created successfully'
            }),
            SupplierActions.loadSuppliers()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while adding the supplier';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(SupplierActions.loadSupplierFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  updateSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.updateSupplier),
      mergeMap(({ supplier }) =>
        this.masterDataService.updateSupplier(supplier).pipe(
          mergeMap(saved => [
            SupplierActions.updateSupplierSuccess({
              supplier: saved,
              message: 'Supplier updated successfully'
            }),
            SupplierActions.loadSuppliers()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while updating the supplier';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(SupplierActions.loadSupplierFailure({ error: errorMessage }));
          })
        )
      )
    )
  );  

  deleteSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.deleteSupplier),
      mergeMap(({ id }) =>
        this.masterDataService.deleteSupplier(id).pipe(
          mergeMap(saved => [
            SupplierActions.deleteSupplierSuccess({
              id: id,
              message: 'Supplier deleted successfully'
            }),
            SupplierActions.loadSuppliers()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while adding the supplier';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(SupplierActions.loadSupplierFailure({ error: errorMessage }));
          })
        )
      )
    )
  );
  
}